import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getResearchCategoryData } from '../services/ResearchCategories.js';
import { useEffect, useMemo, useState } from 'react';
import GeneralResearchCategories from './ResearchCategories/GeneralResearchCategories.js';
import MyTabsNested from '../components/MyTabsNested.js';
import RCPrimaryForm from './ResearchCategories/RCPrimaryForm.js';
import { useSelector } from 'react-redux';
import MyAccordionNested from '../components/MyAccordionNested.js';

const EditResearchCategory = () => {

  const { alias } = useParams();
  const [insightTitle, setInsightTitle] = useState();
  const previewEnabled = useSelector(state => state.preview.isEnabled);
  const location = useLocation();
  const navigate = useNavigate();


  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: GeneralResearchCategories, subTabs: [
        { id: "primary", title: "Primary", Component: RCPrimaryForm }
      ]
    }
  ], []);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getResearchCategoryData(alias);

          if (result) {
            setInsightTitle(result?.data?.[0]?.name);
          }
        }
      } catch (error) {
        console.error('Error fetching film data:', error);
      }
    };

    getBasicData();
  }, [alias]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts?.length === 3 && alias) {
      // Redirect to the default tab/subTab
      navigate(`/research-categories/${alias}/${tabs[0].id}${`/${tabs?.[0].subTabs?.[0]?.id}`}`, { replace: true });
    }
  }, [location.pathname, alias, navigate, tabs]);

  return (
      <Stack px="1rem" pb={'1rem'} width={"100%"}>
     <Box>
       <Text fontSize={"18px"} pt={2} fontWeight={"600"}>{insightTitle}</Text>
     </Box>
      {previewEnabled ?
        <MyAccordionNested orientation="vertical" list={tabs} urlBasePath="/research-categories" /> :
        <MyTabsNested orientation="vertical" list={tabs} urlBasePath={"/research-categories"} />}
    </Stack>
  );
};

export default EditResearchCategory;